export function Company() {
  const experiences = [
    {
      title: '東京ゲームショウ',
      role: 'プロモーター・VIP対応',
      description: '日本最大級のゲーム展示会にて、海外VIPゲストの対応とプロモーション活動を担当。英語・中国語での通訳・アテンドを実施。',
      image: 'https://public.readdy.ai/ai/img_res/c46f3a5a865ab0d70aff06833d85cc7f.jpg'
    },
    {
      title: 'K-POP WORLD FESTA',
      role: 'イベント企画運営・集客マーケティング',
      description: 'KPOPアーティストの大型フェスティバルにて、企画立案から集客マーケティング、当日運営まで一貫して担当。SNS運用で10万人以上にリーチ。',
      image: 'https://readdy.ai/api/search-image?query=kpop%20music%20festival%20with%20spectacular%20stage%20production%20colorful%20concert%20lighting%20enthusiastic%20crowd%20large%20scale%20entertainment%20event%20professional%20production%20dark%20background%20with%20pink%20purple%20blue%20lights&width=600&height=400&seq=exp002&orientation=landscape'
    },
    {
      title: 'アジアビジネスサミット',
      role: '営業・海外クライアント対応',
      description: 'アジア各国の企業が集まるビジネスサミットにて、海外クライアントの営業対応と商談マッチングを担当。中国・韓国・東南アジア企業との橋渡し役を務める。',
      image: 'https://readdy.ai/api/search-image?query=international%20business%20summit%20conference%20with%20professional%20attendees%20networking%20modern%20conference%20venue%20with%20elegant%20lighting%20corporate%20atmosphere%20asian%20business%20event%20dark%20sophisticated%20background&width=600&height=400&seq=exp003&orientation=landscape'
    },
    {
      title: 'チャリティコンサート',
      role: 'イベントプロデュース',
      description: '社会貢献を目的としたチャリティコンサートの企画・プロデュースを担当。アーティストのブッキングから当日の進行管理まで全体を統括。',
      image: 'https://readdy.ai/api/search-image?query=charity%20concert%20event%20with%20warm%20heartfelt%20atmosphere%20stage%20with%20soft%20lighting%20performers%20and%20engaged%20audience%20inspiring%20mood%20professional%20event%20production%20dark%20background%20with%20warm%20accent%20lights&width=600&height=400&seq=exp004&orientation=landscape'
    }
  ];

  return (
    <section id="company" className="py-24 bg-black relative overflow-hidden">
      <div className="absolute top-0 right-0 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-pink-500/10 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <span className="inline-block px-6 py-2 rounded-full bg-gradient-to-r from-pink-500/20 via-purple-500/20 to-blue-500/20 border border-pink-500/30 text-pink-400 text-sm font-semibold tracking-wider mb-6">
            COMPANY
          </span>
          <h2 className="text-3xl sm:text-5xl lg:text-6xl font-black text-white mb-6 whitespace-nowrap" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            代表<span className="bg-gradient-to-r from-pink-400 via-purple-400 to-blue-400 bg-clip-text text-transparent">プロフィール</span>
          </h2>
        </div>

        <div className="mb-20">
          <div className="bg-gradient-to-b from-gray-900/80 to-gray-900/40 rounded-3xl p-12 border border-gray-800">
            <div className="flex flex-col lg:flex-row gap-12">
              <div className="flex-shrink-0">
                <div className="relative">
                  <div className="absolute inset-0 bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500 rounded-3xl blur-xl opacity-30"></div>
                  <img
                    src="https://static.readdy.ai/image/958f03ddcb24e17d7d702f4881f49ed8/07dfe157190dc891bc51a995209279b1.jpeg"
                    alt="代表取締役"
                    className="relative w-40 h-52 sm:w-56 sm:h-72 md:w-72 md:h-96 object-cover object-top rounded-3xl"
                  />
                </div>
              </div>
              <div className="flex-1 space-y-6">
                <div>
                  <p className="text-pink-400 text-sm font-semibold tracking-wider mb-2">FOUNDER & CEO</p>
                  <h3 className="text-3xl font-bold text-white">代表取締役</h3>
                </div>
                <div className="text-gray-300 leading-relaxed space-y-4 text-sm">
                  <p>
                    日本最大級の展示会主催会社にて9年間、BtoB展示会、商業交流会、ライブ配信、授賞式、セミナーなど多様なプロジェクトに従事。プロモーション、営業、SNS運用、VIP対応、イベント運営、撮影業務まで幅広く経験し、「人が集まり、価値が循環する場」の構築に携わる。
                  </p>
                  <p>
                    ハーフとして海外生活も長く、英語・中国語環境に精通。前職では業界横断型の公式WeChatアカウント配信責任者も務め、中華圏を含むグローバルプロモーションの実務を経験。
                  </p>
                  <p>
                    退職後は、商業イベントの枠を越え、一般消費者間で拡散が生まれる構造を研究するため、SNSアルゴリズムを前提としたアカウント運用を開始。ゼロから数十万フォロワー規模へと成長させるなど、デジタル上での拡張モデルを実践的に検証している。
                  </p>
                  <p>
                    また、年間200以上のエンターテインメント現場に足を運ぶ熱量あるファンとしての視点を持ち、ファン心理・消費行動・コミュニティ構造への深い理解を培う。前職で日本の中小企業の「本当に良いもの」が十分に広がっていない現実を目の当たりにした経験から、同様に"原石"のアーティストが正しく評価される機会を創出したいと考えるようになる。
                  </p>
                  <p>
                    アーティストの訴求力、スポンサー企業の価値、そしてファンが形成する経済圏を有機的につなぎ、持続可能なエンターテインメントプラットフォームの構築を目指している。
                  </p>
                </div>
                <div className="flex flex-wrap gap-3">
                  <span className="px-4 py-2 rounded-full bg-pink-500/20 text-pink-400 text-sm whitespace-nowrap">企画設計・イベントプロデュース</span>
                  <span className="px-4 py-2 rounded-full bg-purple-500/20 text-purple-400 text-sm whitespace-nowrap">認知拡張プロモーション戦略</span>
                  <span className="px-4 py-2 rounded-full bg-blue-500/20 text-blue-400 text-sm whitespace-nowrap">英語／中国語対応グローバル連携</span>
                  <span className="px-4 py-2 rounded-full bg-pink-500/20 text-pink-400 text-sm whitespace-nowrap">VIP・ステークホルダーマネジメント</span>
                  <span className="px-4 py-2 rounded-full bg-purple-500/20 text-purple-400 text-sm whitespace-nowrap">SNS成長設計・アルゴリズム分析</span>
                </div>
                <div className="flex items-center gap-6 pt-4">
                  <div className="flex items-center gap-2 text-gray-400">
                    <i className="ri-global-line text-xl text-pink-400"></i>
                    <span>日本語 / 中文 /&nbsp;English</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
